var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.url,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.title)+" "),_c('link-icon')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }